import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/(pages)/noleggio-b2b/[slug]/page.tsx\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"detailFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/noleggio/RentToBuyDetailClient.tsx");
